import React from 'react';
import type { ReviewStatus } from '../core/types';

const STYLES: Record<ReviewStatus, { label: string; className: string }> = {
  untranslated: {
    label: 'Untranslated',
    className: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  },
  machine: {
    label: 'Machine',
    className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  },
  human_reviewed: {
    label: 'Reviewed',
    className: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
  },
};

export function StatusBadge({ status }: { status: ReviewStatus }): React.ReactElement {
  const style = STYLES[status];
  return (
    <span
      className={`inline-block rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${style.className}`}
    >
      {style.label}
    </span>
  );
}
